import { HighlightOff } from "@mui/icons-material";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import useGlobalModal from "./hooks/useGlobalModal";

const GlobalModal = () => {
  const { setModalContent, content, modalProps } = useGlobalModal();

  return (
    <Dialog
      maxWidth="lg"
      onClose={() => setModalContent(null)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      open={Boolean(content)}
      {...modalProps}
    >
      <DialogContent
        sx={{
          padding: "3rem",
          position: "relative",
        }}
      >
        {content}
      </DialogContent>
      <IconButton
        sx={{ position: "absolute", top: ".5rem", right: ".5rem" }}
        size="large"
        color="primary"
        onClick={() => setModalContent(null)}
      >
        <HighlightOff />
      </IconButton>
    </Dialog>
  );
};

export default GlobalModal;
